<div class="tabs" [ngClass]="{'progress': styleProgress, 'groups': styleGroup, 'student':studentStyle}">
    <div class="navigation-wrapper">
        <div class="navigation-container">
            <ul [class]="navClass" class="navigation">
                <li *ngFor="let tab of tabs; let number = index" (click)="selectTab(tab)" class="tab-item"
                    [class.active]="tab.active">

                    <span *ngIf="tab.counterBadge > 0 && !tab.showBlockedIcon" class="counter-badge">
                        {{ tab.counterBadge }}
                    </span>

                    <a class="tab-link">
                        <!--                        <span *ngIf="tab.number && tab.active"-->
                        <!--                              [class.bondle-danger]="tab.type == 'danger'"-->
                        <!--                              [class.bondle-success]="tab.type == 'success'"-->
                        <!--                              class="navigation-number"-->
                        <!--                        >{{ tab.number }}</span>-->

                        <span *ngIf=" tab.svg && tab.active"
                              class="navigation-number">
                            <svg width="21" height="21" viewBox="0 0 21 21" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M12.44 3.06219C11.1967 2.47927 9.80326 2.47927 8.55988 3.06219L2.70515 5.80702C1.76365 6.24842 1.51818 7.49308 1.96875 8.35333L1.96875 12.6875C1.96875 13.0499 2.26256 13.3438 2.625 13.3438C2.98744 13.3438 3.28125 13.0499 3.28125 12.6875V9.33803L8.55995 11.8128C9.80334 12.3957 11.1967 12.3957 12.4401 11.8128L18.2948 9.06798C19.5684 8.47092 19.5684 6.40412 18.2949 5.80706L12.44 3.06219Z"
                                fill="#83B25F"/>
                            <path
                                d="M4.375 11.3004V14.5472C4.375 15.4293 4.81557 16.2551 5.58717 16.6824C6.87199 17.3939 8.9285 18.375 10.5 18.375C12.0715 18.375 14.128 17.3939 15.4128 16.6824C16.1844 16.2551 16.625 15.4293 16.625 14.5472V11.3004L12.9973 13.0012C11.4009 13.7496 9.59919 13.7496 8.00282 13.0012L4.375 11.3004Z"
                                fill="#83B25F"/>
                            </svg>
                        </span>

                        <span *ngIf="tab.svg && !tab.active"
                              class="navigation-number">
                                <svg width="21" height="21" viewBox="0 0 21 21" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M12.44 3.06219C11.1967 2.47927 9.80326 2.47927 8.55988 3.06219L2.70515 5.80702C1.76365 6.24842 1.51818 7.49308 1.96875 8.35333L1.96875 12.6875C1.96875 13.0499 2.26256 13.3438 2.625 13.3438C2.98744 13.3438 3.28125 13.0499 3.28125 12.6875V9.33803L8.55995 11.8128C9.80334 12.3957 11.1967 12.3957 12.4401 11.8128L18.2948 9.06798C19.5684 8.47092 19.5684 6.40412 18.2949 5.80706L12.44 3.06219Z"
                                        fill="#3F403F"/>
                                    <path
                                        d="M4.375 11.3004V14.5472C4.375 15.4293 4.81557 16.2551 5.58717 16.6824C6.87199 17.3939 8.9285 18.375 10.5 18.375C12.0715 18.375 14.128 17.3939 15.4128 16.6824C16.1844 16.2551 16.625 15.4293 16.625 14.5472V11.3004L12.9973 13.0012C11.4009 13.7496 9.59919 13.7496 8.00282 13.0012L4.375 11.3004Z"
                                        fill="#3F403F"/>
                                </svg>

                        </span>
                        <!--                        <span *ngIf="tab.number&& !tab.active"-->
                        <!--                              class="navigation-number bondle-default"-->
                        <!--                        >{{ tab.number }}</span>-->
                        <span class="navigation-text">{{ tab.title }}</span>

                        <span *ngIf="tab.numberAfter"
                              class="navigation-number-after bondle-default"
                        >{{ tab.numberAfter }}</span>
                    </a>
                </li>


                <li class="student-schedule tab-item ion-hide-sm-down" [ngClass]="{'d-none':showSchedule=== false}">
                    <a [routerLink]="'/schedule'">
                        <button type="button" class="btn btn-primary">
                            <svg width="21" height="21" viewBox="0 0 21 21" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M6.78125 2.1875C6.78125 1.82506 6.48744 1.53125 6.125 1.53125C5.76256 1.53125 5.46875 1.82506 5.46875 2.1875V3.56935C4.20934 3.6702 3.38255 3.9177 2.77513 4.52513C2.1677 5.13255 1.9202 5.95934 1.81935 7.21875H19.1806C19.0798 5.95934 18.8323 5.13255 18.2249 4.52513C17.6174 3.9177 16.7907 3.6702 15.5312 3.56935V2.1875C15.5312 1.82506 15.2374 1.53125 14.875 1.53125C14.5126 1.53125 14.2188 1.82506 14.2188 2.1875V3.51129C13.6366 3.5 12.9842 3.5 12.25 3.5H8.75C8.01584 3.5 7.36336 3.5 6.78125 3.51129V2.1875Z"
                                    fill="#3F403F"/>
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M1.75 10.5C1.75 9.76584 1.75 9.11336 1.76129 8.53125H19.2387C19.25 9.11336 19.25 9.76584 19.25 10.5V12.25C19.25 15.5498 19.25 17.1997 18.2249 18.2249C17.1997 19.25 15.5498 19.25 12.25 19.25H8.75C5.45017 19.25 3.80025 19.25 2.77513 18.2249C1.75 17.1997 1.75 15.5498 1.75 12.25V10.5ZM14.875 12.25C15.3582 12.25 15.75 11.8582 15.75 11.375C15.75 10.8918 15.3582 10.5 14.875 10.5C14.3918 10.5 14 10.8918 14 11.375C14 11.8582 14.3918 12.25 14.875 12.25ZM14.875 15.75C15.3582 15.75 15.75 15.3582 15.75 14.875C15.75 14.3918 15.3582 14 14.875 14C14.3918 14 14 14.3918 14 14.875C14 15.3582 14.3918 15.75 14.875 15.75ZM11.375 11.375C11.375 11.8582 10.9832 12.25 10.5 12.25C10.0168 12.25 9.625 11.8582 9.625 11.375C9.625 10.8918 10.0168 10.5 10.5 10.5C10.9832 10.5 11.375 10.8918 11.375 11.375ZM11.375 14.875C11.375 15.3582 10.9832 15.75 10.5 15.75C10.0168 15.75 9.625 15.3582 9.625 14.875C9.625 14.3918 10.0168 14 10.5 14C10.9832 14 11.375 14.3918 11.375 14.875ZM6.125 12.25C6.60825 12.25 7 11.8582 7 11.375C7 10.8918 6.60825 10.5 6.125 10.5C5.64175 10.5 5.25 10.8918 5.25 11.375C5.25 11.8582 5.64175 12.25 6.125 12.25ZM6.125 15.75C6.60825 15.75 7 15.3582 7 14.875C7 14.3918 6.60825 14 6.125 14C5.64175 14 5.25 14.3918 5.25 14.875C5.25 15.3582 5.64175 15.75 6.125 15.75Z"
                                      fill="#3F403F"/>
                            </svg>


                            {{ 'schedule'|transloco }}
                        </button>

                    </a>


                </li>
            </ul>


        </div>
    </div>
    <div class="tab-contents">
        <ng-content></ng-content>
    </div>
</div>
